export function eventToArtifact(event) {

  const evidenceImages =
    event.evidenceImages ||
    event.payload?.evidenceImages ||
    [];

  return {

    id: `${event.clause.clause_id}-${Date.now()}`,

    capturedBy: "Operator",

    workflowType:
      event.payload?.workflow_type ||
      "inspection",

    evidenceType: "Operational Evidence",

    riskLevel:
      event.gaps?.some(
        g => g.severity === "high"
      )
        ? "High"
        : "Medium",

    html: `
      <div>
        <strong>Observation:</strong>
        <p>${event.transcript}</p>
      </div>
    `,

    decisionSignals:
      event.clause.matched_keywords || [],

    evidenceImages,

    audioBase64:
      event.payload?.audioBase64 || null,
  };
}